import React from "react";
import {
  ProgressBarContainer,
  StepsContainer,
  Step,
  ProgressText,
} from "./ProgressBar.styles";
import { ProgressBarProps } from "./ProgressBar.types";
import { Caps1SemiboldTypography } from "../../primitives/Typography/typographyVariants";

export const ProgressBar: React.FC<ProgressBarProps> = ({
  currentStep,
  totalSteps,
  noGutter = false,
}) => {
  const validCurrentStep = Math.min(currentStep, totalSteps);

  const steps = Array.from(
    { length: totalSteps },
    (_, index) => index < validCurrentStep
  );

  return (
    <ProgressBarContainer noGutter={noGutter}>
      <StepsContainer>
        {steps.map((isFilled, index) => (
          <Step key={index} isFilled={isFilled} />
        ))}
      </StepsContainer>

      <ProgressText>
        <Caps1SemiboldTypography>
          {validCurrentStep}/{totalSteps}
        </Caps1SemiboldTypography>
      </ProgressText>
    </ProgressBarContainer>
  );
};
